import { render, staticRenderFns } from "./RBreadcrumbRouter.vue?vue&type=template&id=7d8146c2&"
import script from "./RBreadcrumbRouter.vue?vue&type=script&lang=js&"
export * from "./RBreadcrumbRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports